module.exports = __webpack_public_path__ + "static/media/mpp.8fcca6cb.png";